import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { Coverage } from '@models/swagger';
import { PutCoveragesParams } from './service';

export enum PutCoveragesActions {
  Failure = '[Project PutCoverages] Failure',
  Request = '[Project PutCoverages] Request',
  Success = '[Project PutCoverages] Success',
  Reset = '[Project PutCoverages] Reset',
}

export const PutCoveragesFailure = createAction(PutCoveragesActions.Failure, props<{ error: HttpErrorResponse }>());

export const PutCoveragesRequest = createAction(
  PutCoveragesActions.Request,
  props<{ body: Coverage[]; parameters: PutCoveragesParams }>()
);

export const PutCoveragesSuccess = createAction(PutCoveragesActions.Success, props<{ data: Coverage[] }>());

export const PutCoveragesReset = createAction(PutCoveragesActions.Reset);
